import { batchHandleUrl } from 'fe-coms-share/utils/url-handle.js'
const api = {
  preview: {
    url: '/apaas/file/preview',
    type: 'post'
  }
}
export default batchHandleUrl(api)
